<crm-auto-complete
  [(value)]="selectedClient"
  (valueChange)="selectedClientChange.emit($event)"
  [styleClass]="styleClass"
  [class]="class"
  [disabled]="disabled"
  [inputStyle]="inputStyle"
  [suggestions]="clients"
  [field]="field"
  [virtualScroll]="true"
  [virtualScrollItemSize]="40"
  [inputStyleClass]="inputStyleClass"
  dataKey="id"
  [appendTo]="appendTo"
  [placeholder]="placeholder"
  [isError]="isError"
  [showClear]="showClear"
  (completeMethod)="customSearch ? clientSearch.emit($event.query) : searchClient($event.query)">
  <ng-template
    let-item="item"
    #itemTemplate>
    <div *ngIf="toClient(item) as client">
      <div>{{ client.name }}</div>
    </div>
  </ng-template>
</crm-auto-complete>
